export default __webpack_public_path__ + "static/media/ProgressStage4.9c6f4dfb.svg";